// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stripe-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 1rem;
}

.stripe-modal-content {
    background: linear-gradient(135deg, rgba(20, 20, 20, 0.95) 0%, rgba(30, 30, 30, 0.98) 100%);
    border: 1px solid rgba(213, 190, 155, 0.3);
    border-radius: 20px;
    width: 100%;
    max-width: 500px;
    padding: 2rem;
    position: relative;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
    color: #fff;
}

.stripe-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
}

.stripe-modal-title {
    font-family: 'CormorantSC-Regular', serif;
    font-size: 1.5rem;
    color: rgba(213, 190, 155, 1);
    margin: 0;
}

.stripe-modal-close {
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    padding: 0.5rem;
    transition: color 0.2s;
}

.stripe-modal-close:hover {
    color: #fff;
}

.stripe-payment-form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

/* Stripe Element Customization Wrapper if needed */
.stripe-element-container {
    padding: 1rem;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.stripe-submit-btn {
    width: 100%;
    padding: 1rem;
    background: linear-gradient(180deg, rgba(213, 190, 155, 0.9) 0%, rgba(189, 153, 107, 0.95) 100%);
    border: none;
    border-radius: 8px;
    color: #000;
    font-family: 'Urbanist-Bold', sans-serif;
    font-weight: bold;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 1rem;
}

.stripe-submit-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(213, 190, 155, 0.4);
}

.stripe-submit-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.stripe-error-message {
    color: #ff6b6b;
    font-size: 0.9rem;
    text-align: center;
    margin-top: 0.5rem;
}

.pk-input-container {
    margin-bottom: 1rem;
}

.pk-input {
    width: 100%;
    padding: 0.8rem;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(213, 190, 155, 0.3);
    border-radius: 8px;
    color: rgba(213, 190, 155, 1);
    font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/userCenter/StripePaymentModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,qCAAqC;IACrC,0BAA0B;IAC1B,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,2FAA2F;IAC3F,0CAA0C;IAC1C,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,gDAAgD;IAChD,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,yCAAyC;IACzC,iBAAiB;IACjB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gGAAgG;IAChG,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,wCAAwC;IACxC,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,8BAA8B;IAC9B,0CAA0C;IAC1C,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;AACrB","sourcesContent":[".stripe-modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.75);\r\n    backdrop-filter: blur(5px);\r\n    -webkit-backdrop-filter: blur(5px);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n    padding: 1rem;\r\n}\r\n\r\n.stripe-modal-content {\r\n    background: linear-gradient(135deg, rgba(20, 20, 20, 0.95) 0%, rgba(30, 30, 30, 0.98) 100%);\r\n    border: 1px solid rgba(213, 190, 155, 0.3);\r\n    border-radius: 20px;\r\n    width: 100%;\r\n    max-width: 500px;\r\n    padding: 2rem;\r\n    position: relative;\r\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\r\n    color: #fff;\r\n}\r\n\r\n.stripe-modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.stripe-modal-title {\r\n    font-family: 'CormorantSC-Regular', serif;\r\n    font-size: 1.5rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    margin: 0;\r\n}\r\n\r\n.stripe-modal-close {\r\n    background: transparent;\r\n    border: none;\r\n    color: rgba(255, 255, 255, 0.5);\r\n    cursor: pointer;\r\n    padding: 0.5rem;\r\n    transition: color 0.2s;\r\n}\r\n\r\n.stripe-modal-close:hover {\r\n    color: #fff;\r\n}\r\n\r\n.stripe-payment-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1.5rem;\r\n}\r\n\r\n/* Stripe Element Customization Wrapper if needed */\r\n.stripe-element-container {\r\n    padding: 1rem;\r\n    background: rgba(255, 255, 255, 0.05);\r\n    border-radius: 8px;\r\n    border: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.stripe-submit-btn {\r\n    width: 100%;\r\n    padding: 1rem;\r\n    background: linear-gradient(180deg, rgba(213, 190, 155, 0.9) 0%, rgba(189, 153, 107, 0.95) 100%);\r\n    border: none;\r\n    border-radius: 8px;\r\n    color: #000;\r\n    font-family: 'Urbanist-Bold', sans-serif;\r\n    font-weight: bold;\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    margin-top: 1rem;\r\n}\r\n\r\n.stripe-submit-btn:hover:not(:disabled) {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(213, 190, 155, 0.4);\r\n}\r\n\r\n.stripe-submit-btn:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.stripe-error-message {\r\n    color: #ff6b6b;\r\n    font-size: 0.9rem;\r\n    text-align: center;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n.pk-input-container {\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.pk-input {\r\n    width: 100%;\r\n    padding: 0.8rem;\r\n    background: rgba(0, 0, 0, 0.3);\r\n    border: 1px solid rgba(213, 190, 155, 0.3);\r\n    border-radius: 8px;\r\n    color: rgba(213, 190, 155, 1);\r\n    font-size: 0.9rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
